export default {
    公司制度文件:'Relevant Documents',
    // desc:'The report comprehensively elaborates and demonstrates research contents and methods of the industry and listed companies, and systematically arranges and analyzes the data obtained in the research.'
}
